
module.config(function($stateProvider) {

    $stateProvider.state('preLogin', {
        parent: 'behind',
        allowAnon: true,
        offcanvasHidden: true,
        templateUrl: 'empty',
        params: {
            returnName: 'home',
            returnParams: {},
        },
        controller: function($scope, $state, $stateParams, $window) {
            $scope.slackRedirect = $window.location.protocol + '//' + $window.location.hostname + '/slack-login';
            $scope.returnParams = $stateParams;
            $scope.doReturn = function(reload) {
                reload = angular.isUndefined(reload) ? true : !!reload;
                return $state.go($stateParams.returnName || 'home',
                                 $stateParams.returnParams || {},
                                 {reload: reload});
            };
        },
    })

    $stateProvider.state('loginBase', {
        allowAnon: true,
        offcanvasHidden: true,
        parent: 'preLogin',
        templateUrl: 'page/loginBase',
    });

    $stateProvider.state('login', {
        allowAnon: true,
        offcanvasHidden: true,
        params: {message: null, notError: null},
        parent: 'loginBase',
        templateUrl: 'page/login',
        controller: 'LoginPageController',
    });

    $stateProvider.state('loadingIdentity', {
        allowAnon: true,
        offcanvasHidden: true,
        parent: 'preLogin',
        template: '<p class="loading"><i class="fa fa-spin fa-spinner"></i></p>',
        controller: function($scope, Principal) {
            Principal.resolve().then($scope.doReturn);
        },
    });

    $stateProvider.state('logout', {
        allowAnon: true,
        offcanvasHidden: true,
        parent: 'basic',
        controller: function($state, $location, Principal) {
            Principal.logout().then(function() {
                $state.transitionTo("home", {reload: true, location: true});
            });
        },
    });

    $stateProvider.state('reset', {
        allowAnon: true,
        offcanvasHidden: true,
        parent: 'loginBase',
        templateUrl: 'page/reset',
        controller: 'RequestResetController',
    });

    $stateProvider.state('slackLogin', {
        allowAnon: true,
        offcanvasHidden: true,
        template: "<p class='red'>{{message}}</p>",
        parent: 'behind',
        url: '/slack-login?code?state?error',
        resolve: {
            loginError: function($stateParams, Principal) {
                if ($stateParams.error) {
                    if ($stateParams.error === 'access_denied') {
                        return "Login with Slack permission denied by user."
                    }
                    return $stateParams.error;
                }

                return Principal
                    .slackLogin($stateParams.code, $stateParams.state)
                    .then(function() { return false; },
                          function(error) { return error; })
            },
        },
        controller: function($location, $state, loginError) {
            if (!loginError) {
                $location.url('/').replace();
            } else {
                $state.go('login', {message: loginError});
            }
        },
    });

    $stateProvider.state('tokenLogin',  {
        allowAnon: true,
        offcanvasHidden: true,
        template: "<p class='red'>{{message}}</p>",
        parent: 'loginBase',
        url: '/login?token?type',
        resolve: {
            loginError: function($stateParams, Principal) {
                return Principal.tokenLogin($stateParams.token,
                                            $stateParams.type)
                    .then(function() { return false; },
                          function(error) { return error; })
            },
        },
        controller: function($location, $state, loginError) {
            if (!loginError) {
                $location.url('/').replace();
            } else {
                $state.go('login', {message: loginError});
            }
        },
    });

    $stateProvider.state('resetForm', {
        offcanvasHidden: true,
        parent: 'loginBase',
        templateUrl: 'page/resetForm',
        controller: 'ResetFormController',
    });

    $stateProvider.state('updateContact', {
        offcanvasHidden: true,
        parent: 'loginBase',
        templateUrl: 'page/updateContact',
        controller: 'UpdateContactController',
    });
});

module.cC({
    name: 'LoginPageController',
    inject: ['$scope', '$state', '$stateParams', 'Principal', '$q'],
    data: {Principal: 'Principal', data: '{}'},

    init: function() {
        if (this.$stateParams.message) {
            this.$.message = this.$stateParams.message;
            this.$.notError = this.$stateParams.notError;
        }
        if (this.Principal.is_authenticated) {
            this._setTitle("Login Expired",
                           "Please re-enter your password to continue.")
        }
    },

    methods: {

        clearPrincipal: function() {
            this.Principal.logout().then(this._clearTitle());
        },

        login: function() {
            var Principal = this.Principal, username;
            if (this.$.form.$invalid) {
                this._setErrorMessage("Please enter username and password.");
                return this.$q.reject();
            }

            username = (Principal.is_authenticated ?
                        Principal.username :
                        this.data.username);

            return Principal.login(username, this.data.password)
                .then(this._checkActiveLogin)
                .catch(this._setErrorMessage);
        },

        _checkActiveLogin: function(principal) {
            if (principal.is_anonymous) {
                // Login request successful but user is not logged in.
                this.data = this.$.data = {};
                return this.$q.reject("This account has been deactivated. Please contact support.");
            }
            return principal;
        },

        _clearPassword: function() {
            delete this.data.password;
        },

        _setErrorMessage: function(error) {
            this.$.message = error;
            this.$.notError = false;
            return this.$q.reject(error);
        },

        _setTitle: function(title, message) {
            this.$.title = title;
            this.$.message = message;
        },

        _clearTitle: function() {
            this._setTitle(undefined, undefined);
        },
    },
});


module.cC({
    name: 'ResetFormController',
    inject: ['$scope', '$q', 'Principal'],
    data: {data: '{}'},
    methods: {
        submit: function(form, data) {
            if (form.$invalid) return this.$q.reject();
            return this.Principal.changePassword(data.password);
        }
    }
});


module.cC({
    name: 'UpdateContactController',
    inject: ['$scope', '$q', 'Principal'],
    data: {'data': '{}'},
    init: function() {
        this.data.first_name = this.Principal.first_name;
        this.data.last_name = this.Principal.last_name;
        this.data.email = this.Principal.email;
    },

    methods: {
        submit: function(form, data) {
            if (form.$invalid) return this.$q.reject();
            return this.Principal.update(data);
        },
    },
});

module.cC({
    name: "RequestResetController",
    inject: ['$scope', '$q', '$state', 'Principal'],
    data: {data: '{}'},
    methods: {
        submit: function(form, email) {
            if (form.$invalid) return this.$q.reject();
            return this.Principal.resetPassword(email);
        },
        doReturn: function() {
            return this.$state.go('login', {
                message: "Password reset instructions have been emailed to you.",
                notError: true,
            });
        },
    },
});